/**
* This file was auto-generated by the FrontendConstantsGenerator.
* Do not make direct changes to the file.
*/

export const NotableTypes = {"ACCOUNT":"Account","ORGANIZATION":"Organization","PROJECT":"Project","TEAM":"Team"}
